export const formatDateWithUTCOffset = (date: Date | null | undefined) => {
  if (!date) return null;

  const offset = date.getTimezoneOffset();
  const offsetHour = offset / 60;

  const adjustedDate = new Date(date.getTime() + offsetHour * 60 * 60 * 1000);
  return adjustedDate;
};
